export default __webpack_public_path__ + "static/media/review-1.4c23376a.png";